<template>
  <IQOS required class="gap-row-xs" :title="$t('discount_card.title')">
    <div class="gap-row-1xs">
      <p class="iqos-comment qrw-label-sm">
        {{ $t("discount_card.size") }}
      </p>
      <p class="iqos-comment qrw-label-sm v1-grey-10-color">
        {{ promotion.discount }}%
      </p>
    </div>

    <div class="gap-row-1xs">
      <p class="iqos-comment qrw-label-sm">
        {{ $t("discount_card.conditions") }}
      </p>
      <p class="iqos-comment qrw-label-sm v1-grey-10-color">
        {{ promotion.target.menu_name }} |
        {{
          promotion.target.category_id
            ? promotion.target.category_name
            : $t("add_discount.all_categories")
        }}
        |
        {{
          promotion.target.product_id
            ? promotion.target.product_name
            : $t("add_discount.all_products")
        }}
        |
        {{
          promotion.target.modificator_id
            ? promotion.target.modificator_name
            : $t("add_discount.all_modificators")
        }}
      </p>
    </div>
    <div class="gap-row-1xs">
      <p class="iqos-comment qrw-label-sm">
        {{ $t("discount_card.period") }}
      </p>
      <p class="iqos-comment qrw-label-sm v1-grey-10-color">
        {{ promotion.period_start | formatDate }} -
        <span v-if="promotion.period_end">
          {{ promotion.period_end | formatDate }}</span
        >
        <span v-else>∞</span>
      </p>
    </div>
    <div class="iqos-flex-right">
      <BaseButton
        icon="trash"
        size="md"
        variant="secondary"
        color="red-4"
        @click="remove"
      >
        {{ $t("discount_card.delete_btn") }}
      </BaseButton>
    </div>

    <template #actions>
      <IQOSToggle v-model="promotion.is_active" />
    </template>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSToggle from "@/components/IQOSToggle.vue";
import DashboardButton from "@/components/DashboardButton.vue";

import PromotionsAPI from "@/api/promotions";

export default {
  props: {
    promotion: Object,
  },
  watch: {
    "promotion.is_active"() {
      this.updatePromotion();
    },
  },
  computed: {
    promotionDescription() {
      const texts = [
        this.$t("discount_card.applies_to_menu", {
          menu: this.promotion.target.menu_name,
        }),
      ];

      if (this.promotion.target.category_id) {
        texts.push(
          this.$t("discount_card.applies_to_category", {
            category: this.promotion.target.category_name,
          })
        );
      }

      if (this.promotion.target.product_id) {
        texts.push(
          this.$t("discount_card.applies_to_product", {
            product: this.promotion.target.product_name,
          })
        );
      }

      return texts.join(", ");
    },
  },
  methods: {
    remove() {
      PromotionsAPI.remove(this.promotion._id)
        .then((data) => {
          this.$emit("deleted");

          this.$store.dispatch("auditlog/write", {
            type: "delete_discount",
            payload: {
              id: this.promotion._id,
              size: this.promotion.discount,
            },
          });
        })
        .catch((err) => {
          alert(err);
        });
    },
    updatePromotion() {
      PromotionsAPI.update(this.promotion._id, this.promotion)
        .then((data) => {
          this.$emit("updated");
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
  components: {
    IQOS,
    IQOSToggle,
    DashboardButton,
  },
};
</script>

<style>
</style>